<template>
  <div
    class="card shadow position-relative"
    style="min-height:120px;"
  >
    <div
      v-if="canEdit"
      class="position-absolute cursor-pointer"
      style="right:8px; top: 8px;"
      @click="edit"
    >
      <v-icon icon="pen" />
    </div>
    <div class="card-body">
      <div class="d-flex flex-column">
        <div class="d-flex mx-auto mb-1">
          <v-icon
            icon="puzzle"
            width="24"
            height="24"
            folder="common/svg"
          />
        </div>
        <div class="d-flex mx-auto mb-1">
          {{ title }}
        </div>
        <div
          v-if="activities.length === 0"
          class="d-flex flex-column text-center fw-bold"
        >
          Aucune activité complémentaire
        </div>
        <div
          v-else
          class="d-flex flex-column text-center fw-bold"
        >
          <div
            v-for="activity in activities.slice(0, 2)"
            :key="activity.id"
            class="d-flex mx-auto"
          >
            {{ activity.name }}
          </div>
        </div>
        <div
          v-if="canEdit && activities.length > 2"
          class="d-flex flex-row mx-auto cursor-pointer mt-1"
          @click="edit"
        >
          <v-icon icon="plus" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContractSmallActivities',
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit'],
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    canEdit() {
      return this.isEditable && this.contract.status === 'AMENDMENT';
    },
    activities() {
      return this.contract.risk.activities || [];
    },
    title() {
      return this.activities.length <= 1
        ? 'Activité complémentaire'
        : 'Activités complémentaires';
    },
  },
  methods: {
    edit() {
      this.$emit('edit', 'activity');
    },
  },
};
</script>
